/**
 * @author Radek Liška <ing.radek.liska@gmail.com>
 * @author Vladislav Urbánek <urbanek.vlada@gmail.com>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

/**
 * Továrna pro potřeby ovladače PDF souborů.
 */
class PdfViewerControllerFactory {
  /**
   * Vytvoří instanci
   * @param {Class.<PdfViewerController>} PdfViewerController
   * @param {ViewerLifeCycleFactory} viewerLifeCycleFactory
   */
  constructor(PdfViewerController, viewerLifeCycleFactory) {
    this.PdfViewerController = PdfViewerController;
    this.viewerLifeCycleFactory = viewerLifeCycleFactory;
  }

  /**
   * Vytvoří nový ovladač pro zobrazení video streamu.
   * @returns {PdfViewerController} Vytvořený ovladač.
   */
  create() {
    return new this.PdfViewerController(this.viewerLifeCycleFactory);
  }
}

export default PdfViewerControllerFactory;
